export default __webpack_public_path__ + "static/5-fddf9094e51c2a444d4613870633a975.jpeg";